import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { urlHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';
import { queryTypes, servicesEtmenTurleriTypes } from 'src/types';

export const etmenTurleriLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesEtmenTurleriTypes.EtmenTurleriLookupDataType): AxiosPromise<servicesEtmenTurleriTypes.EtmenTurleriLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.etmenTurleri), {
    blockSpinner,
  });
};

export const etmenTurleriMapLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesEtmenTurleriTypes.EtmenTurleriLookupDataType): AxiosPromise<servicesEtmenTurleriTypes.EtmenTurleriLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, `${urlsConfig.generics.common.etmenTurleri}/map`), {
    blockSpinner,
  });
};

export const etmenTurleriSingleLookup = (
  id: number,
  { blockSpinner }: servicesEtmenTurleriTypes.EtmenTurleriLookupDataType,
): AxiosPromise<servicesEtmenTurleriTypes.EtmenTurleriResultType> => {
  return axios.get(`${urlsConfig.generics.common.etmenTurleri}/${id}`, {
    blockSpinner,
  });
};
